// extracted by mini-css-extract-plugin
export default {"root":"SimpleReveal_root__VbbUg","reveal":"SimpleReveal_reveal__s2qEM","unreveal":"SimpleReveal_unreveal__ZFXB7"};